module.exports = __webpack_public_path__ + "img/AI.27408b4c.png";